import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-func-method'

export const RESOURCE = {
  payload: {
    description: 'Service Center',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'SERVICE_CENTER',
    name: 'Service Center',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
